
































































































































import { Component, Prop } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { SimproJobEntities } from '@/components/add business objects/models/simproJobs';
import Vue from 'vue';

@Component({
	components: {},
	mixins: [validationMixin],
})
export default class AddJobFormEntityList extends Vue {
	@Prop()
	public entities!: SimproJobEntities;

	@Prop()
	public jobType!: string;

	@Prop()
	public sensorFaultReasonOptions!: { text: string; value: any }[];

	@Prop()
	public transceiverFaultReasonOptions!: { text: string; value: any }[];

	@Prop()
	public faultReasonOptions!: { text: string; value: any }[];

	@Prop()
	public v: any;

	@Prop({ default: false })
	public editing!: boolean;

	// Typed as any instead of string because left side of arithmetic where function is used "must be any, number or bigint"
	public renamedLidarType(optionType: string): any {
		return optionType === 'lidarDistance' ? 'volumeSensorDistance' : optionType;
	}

	public entityInstallStateOptions = [
		{ value: 'newSite', text: 'New Site' },
		{ value: 'existingSite', text: 'New Install on Existing Site' },
		{ value: 'reinstall', text: 'Reinstall on Existing Site' },
	];

	public entityAccessibilityOptions = [
		{ value: null, text: 'Unknown' },
		{ value: 'easy', text: 'Easy' },
		{ value: 'difficult', text: 'Difficult' },
	];

	public entityLocatedNearOptions = [
		{ value: null, text: 'Not located near anything' },
		{ value: 'transceiver', text: 'An existing transceiver' },
		{ value: 'mains', text: 'Mains power' },
	];

	public waterEntityInstallResponsibilityOptions = [
		{ value: null, text: 'Levno to install' },
		{ value: 'exists', text: 'Already installed' },
		{ value: 'thirdParty', text: 'Third party to install' },
	];

	public waterTankMaterialOptions = [
		{ value: 'plastic', text: 'Plastic' },
		{ value: 'concrete', text: 'Concrete' },
		{ value: 'other', text: 'Other' },
	];

	public feedTypeOptions = [
		{ value: 'wet', text: 'Wet' },
		{ value: 'dry', text: 'Dry' },
	];

	public feedTankMaterialOptions = [
		{ value: 'plastic', text: 'Plastic' },
		{ value: 'fibreglass', text: 'Fibreglass' },
		{ value: 'metal', text: 'Metal' },
		{ value: 'other', text: 'Other' },
	];

	public getSensors(option: any) {
		return option.value.entity.sensors
			? option.value.entity.sensors
			: option.value.entity.sensor != null
			? [option.value.entity.sensor]
			: [];
	}

	public isInstallJob(): boolean {
		return this.jobType === 'install';
	}

	public isRepairJob(): boolean {
		return this.jobType === 'repair';
	}

	public updateValidation() {
		this.$emit('input');
	}
}
